<template>
  <div>
    <NavMenu />
    <div class="about m-2">
      <h1>Olá, {{ user.firstname }}</h1>
      <p>Bem vindo ao {{ appName }}, <br>
        Para visualizar seus produtos <a href="/products">clique aqui</a></p>
    </div>

    <h2 class="text-center mt-4">Tutorial Meu Como Usar O Meu Ateliê</h2>

    <div class="d-flex justify-content-center">
      <div class="embed-responsive embed-responsive-16by9" style="width: 80%; max-width: 800px;">
        <iframe
          class="embed-responsive-item"
          :src="youtubeVideoUrl"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
          title="Tutorial Meu Como Usar O Meu Ateliê"
        ></iframe>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import store from "@/store"
import NavMenu from "@/views/NavMenu"
import Footer from '@/views/Footer.vue'

export default {
    data(){
      return {
        email: null,
        user: null,
        count: 0,
        appName:"Meu Ateliê",
        youtubeVideoUrl: "https://www.youtube.com/embed/RZibZc5aPRE?rel=0&autoplay=1&&controls=0&showinfo=0&disablekb=1&modestbranding=1"
      }
    },
    methods:{
      testeNotification(){
        this.count++
        store.dispatch('pushNotification', {show:true, message:`Teste ${this.count}`, variant:"danger", id: this.count})
      }
    },
  created() {
    this.user = JSON.parse(localStorage.getItem("user") || "{}")
      this.appName = process.env.VUE_APP_NAME
    },
    components: {NavMenu, Footer}
}

</script>

<style scoped>
/* Estilos opcionais para ajustar ainda mais o layout */
.about {
  text-align: center;
  margin-bottom: 20px;
}
</style>
